import { Layout_WithUser } from '@components/WithUser/WithUser';
import { getBusinessSignupFlowForRequest } from '@modules/server-utils/business-signup-flow';
import { SignUp } from 'app-next/onboarding/business/signup/page';
import type { GetServerSideProps } from 'next';
import type { NextPageWithLayout } from 'pages/_app';

const SignUpPage: NextPageWithLayout = () => {
  return <SignUp />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const flow = await getBusinessSignupFlowForRequest(context);

  if (flow === 'replacement') {
    const query = context.resolvedUrl.split('?')[1];
    const destination = query ? `/business-signup?${query}` : '/business-signup';

    return {
      redirect: {
        destination,
        permanent: false,
      },
    };
  }

  return { props: {} };
};

SignUpPage.getLayout = (page) => {
  return <Layout_WithUser redirect={false}>{page}</Layout_WithUser>;
};

export default SignUpPage;
